export function omit<T extends object, K extends keyof T = never>(
    obj: T,
    fields: K[] | readonly K[]
): Omit<T, K> {
    const clone = { ...obj };

    if (Array.isArray(fields)) {
        fields.forEach((key) => {
            delete clone[key];
        });
    }

    return clone;
}
